import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { addDesc, editDesc, lookDesc } = useMaintenanceDetailsModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }    
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const orderStatistics: IDescription[] = [
        {
            label: Locale["Man-hours"],//"工时数",
            value: typeDesc[mode].workHours.toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Labor Cost"],//"工时费",
            value: typeDesc[mode].workHoursTotal.toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Material Cost"],//"零件费",
            value: typeDesc[mode].partsTotal.toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Preferential amount"],//"优惠金额",
            value: typeDesc[mode].discountAll.toFixed(2),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: Locale["taxation"],//"税费",
        //     value: typeDesc[mode].taxationAll.toFixed(2),
        //     color: DescriptionColorEnum.red,
        //     status: true
        // },
        {
            label: Locale["Total Amount"],//"费用合计",
            value: typeDesc[mode].receivableAll.toFixed(2),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}